
export const getEnv = () => {
  switch (window.location.host) {
      case 'enterprise.taxbit.com':
      case 'blockfi.enterprise.taxbit.com':
          return 'prod';
      case 'enterprise-staging.taxbit.com':
      case 'blockfi.enterprise-staging.taxbit.com':
          return 'staging';
      default:
          return 'local';
  }
};

//TODO: We should investigate having this be a variable that is passed in
export const getAuthIssuerFromEnv = () => {
  const env = getEnv()
  switch(env){
    case 'prod':
      return 'https://dev-54853358.okta.com/oauth2/ausywjgy4X6ZQGMtY5d6'
    case 'local':
    case 'staging':
    default:
      return 'https://dev-7867601.okta.com/oauth2/ausu4a8n7DvPcmHLp5d6'
  }
}

export const getAuthClientIdFromEnv = () => {
  const env = getEnv()
  switch(env){
    case 'prod':
      return '0oaywj4tktfBLGpTb5d6'
    case 'local':
    case 'staging':
    default:
      return '0oawtsb4sL4P7McOV5d6'
  }
}

export const getApiFromEnv = () => {
  const env = getEnv()
  switch(env){
    case 'local':
      return 'https://enterprise-staging.taxbit.com/api'
    default:
      return `${window.origin}/api`
  }
}

export const dateFormatter = (date) => {
  const formattedDate = new Date(date).toLocaleDateString();
  return formattedDate;
}

export const getFullName = (firstName = 'Customer Name', lastName = '') => {
  return `${firstName} ${lastName}`
}

export const formatFiat = (quantity) => {
  return Math.abs(quantity).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const formatAsset = (quantity) => {
  return Math.abs(quantity).toFixed(10).replace(/\.?0+$/, '');
}

export const formatNumber = (num) => {
  return new Intl.NumberFormat().format(num)
}

export const filterAssets = (assets) => {
  const filteredList = assets.filter((asset) => {
    return asset.total_qty.quantity > 0 && asset.total_cost.quantity > 0
  })
  return sortAssetsByQuantity(filteredList);
}

export const sortAssetsByQuantity = (assets) => {
  return assets.sort((assetA, assetB) =>  assetB.total_qty.quantity - assetA.total_qty.quantity)
}